import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import { MessageDescriptorPropType } from '../../prop-types/intl';
import ButtonWithTooltip from './reusable-grid-button-with-tooltip';
import { emptyObject } from 'ui-components/default-props/empty';

import style from './reusable-grid-button.module.less';

const ReusableGridButton = ({
  messageDescriptor = null,
  messageValues = emptyObject,
  tooltipMessageDescriptor = null,
  actionHandler = noop,
  theme = '',
  disable = false,
  hasTooltip = false,
}) => {
  if (hasTooltip) {
    return (
      <ButtonWithTooltip
        disable={disable}
        messageDescriptor={messageDescriptor}
        onClick={actionHandler}
        theme={theme}
        tooltip={<FormattedMessage {...tooltipMessageDescriptor} />}
      />
    );
  }

  return (
    <FormattedMessage {...messageDescriptor} values={messageValues}>
      {(buttonText) => {
        return (
          <Button className={style['reusable-button']} disabled={disable} onClick={actionHandler} theme={theme}>
            {buttonText}
          </Button>
        );
      }}
    </FormattedMessage>
  );
};

ReusableGridButton.propTypes = {
  messageDescriptor: MessageDescriptorPropType,
  messageValues: PropTypes.object,
  tooltipMessageDescriptor: MessageDescriptorPropType,
  actionHandler: PropTypes.func,
  theme: PropTypes.string,
  disable: PropTypes.bool,
  hasTooltip: PropTypes.bool,
};

export default ReusableGridButton;
